"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Heading = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Heading = function Heading(_ref) {
  var children = _ref.children,
      fontSize = _ref.fontSize,
      _ref$level = _ref.level,
      level = _ref$level === void 0 ? 1 : _ref$level,
      _ref$weight = _ref.weight,
      weight = _ref$weight === void 0 ? 'bold' : _ref$weight;
  var HeadingTag = "h".concat(level);
  var size = fontSize !== null && fontSize !== void 0 ? fontSize : level;
  return /*#__PURE__*/_react.default.createElement(HeadingTag, {
    className: (0, _classnames.default)(["text-".concat(11 - size)], _defineProperty({}, "font-weight-".concat(weight), weight))
  }, children);
};

exports.Heading = Heading;
Heading.displayName = 'Heading';